<div>
    <table class="table table-responsive grid annual-details-table">
        <thead class="years">
            <tr>
                <th class="blank" colspan="2"> </th>
                @for (year of years; track year) {
                    <th [class.expanded]="year.expanded" [attr.data-sd-annual-year]="year.annualYear1">
                        {{ year.annualYear1 }}
                        @if (year.annualGridDetails.length > 1) {
                            <span
                                class="float-end pointer"
                                (click)="year.expanded = !year.expanded"
                                [attr.data-sd-expand-year-revisions]
                                [attr.data-sd-annual-year]="year.annualYear1"
                            >
                                @if (!year.expanded) {
                                    <i class="fa fa-plus-circle fa-fw"></i>
                                }
                                @if (year.expanded) {
                                    <i class="fa fa-minus-circle fa-fw"></i>
                                }
                            </span>
                        }
                    </th>
                }
                @if (years?.length === 10 && years[0].totalNumberofYears > 10) {
                    <th class="blank"> </th>
                }
            </tr>
        </thead>
        <tbody class="details">
            @if (filings.length || hasComplianceResponsibility) {
                <tr>
                    <td class="heading"> Comp </td>
                    <td class="heading">
                        @for (filingType of filings; track filingType) {
                            <div style="white-space: nowrap"> {{ filingType.filingTypeName }}:</div>
                        }
                    </td>
                    @for (year of years; track year) {
                        <td class="clickable" style="padding: 0px">
                            <div class="cell-item comp-cell">
                                <table>
                                    <tr>
                                        <td
                                            class="revision"
                                            (click)="complianceClicked(year)"
                                            [attr.data-sd-annual-year]="year.annualYear1"
                                            [attr.data-sd-annual-year-comp-cell]
                                        >
                                            @for (filingType of filings; track filingType) {
                                                <div
                                                    class="year-linked-cell"
                                                    helpTooltip
                                                    helpContentId="annual-details.phantom-year"
                                                    position="top"
                                                    [tooltipDelay]="0"
                                                    [helpDisabled]="!isFromConsolidated(year, filingType)"
                                                >
                                                    @if (isFromConsolidated(year, filingType)) {
                                                        <i class="year-linked fa fa-chain"></i>
                                                    }
                                                    <span
                                                        [innerHtml]="
                                                            annualDetailsService.getComplianceDisplay(
                                                                filingType.filingTypeId,
                                                                year.complianceFilingTypeSummaries
                                                            )
                                                        "
                                                    ></span>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    }
                </tr>
            }
            <tr>
                <td class="heading"> Asmts </td>
                <td class="heading">
                    <strong class="invisible">Revision:</strong>
                    @for (
                        comp of annualDetailsService.nonCapComponents(components, componentTypes, viewTaxableValues);
                        track comp
                    ) {
                        <div> {{ annualDetailsService.getComponentName(comp, componentTypes) }}</div>
                    }
                    @if (viewTaxableValues) {
                        <div class="sum-label">Total MV:</div>
                    } @else {
                        <div class="sum-label">Total FMV:</div>
                    }
                    @for (
                        comp of annualDetailsService.capComponents(components, componentTypes, viewTaxableValues);
                        track comp;
                        let i = $index
                    ) {
                        <div [ngClass]="{ 'cap-component': i === 0 }">{{
                            annualDetailsService.getComponentName(comp, componentTypes)
                        }}</div>
                    }
                    @if (viewTaxableValues) {
                        @for (
                            taxableName of annualDetailsService.taxableValueNames(years);
                            track taxableName;
                            let i = $index
                        ) {
                            <div
                                class="taxable-value-label"
                                [ngClass]="{ 'cap-component': i === 0 }"
                                [title]="taxableName + ':'"
                                >{{ taxableName }}:</div
                            >
                        }
                    }
                </td>
                @for (year of years; track year) {
                    <td class="clickable" [class.expanded]="year.expanded" [style.cursor]="notAllowedIfConsolidated">
                        <!-- | orderBy: '-annualYear1'">-->
                        <div class="cell-item">
                            <table style="width: 100%">
                                <tr>
                                    @for (revision of year.annualGridDetails; track revision) {
                                        <td
                                            class="revision"
                                            [class.not-actual]="revision.status === 0 && !isConsolidatedParcel"
                                            [style.cursor]="notAllowedIfConsolidated"
                                        >
                                            <!-- | orderBy: '-revisionNum'">-->
                                            <div
                                                class="lines"
                                                (click)="revisionClicked(year, revision)"
                                                [attr.data-sd-annual-year-revision]="revision.revisionDesc"
                                                [attr.data-sd-annual-year]="year.annualYear1"
                                            >
                                                <div>
                                                    <strong>{{ revision.revisionDesc }}</strong>
                                                </div>
                                                @for (
                                                    comp of annualDetailsService.nonCapComponents(
                                                        components,
                                                        componentTypes,
                                                        viewTaxableValues
                                                    );
                                                    track comp
                                                ) {
                                                    <div
                                                        [attr.data-sd-assessment-component-name]="
                                                            annualDetailsService.getComponentName(comp, componentTypes)
                                                        "
                                                        [attr.data-sd-annual-year]="year.annualYear1"
                                                    >
                                                        <!-- | orderBy:compPos">-->
                                                        {{
                                                            annualDetailsService.getDisplayAssessment(
                                                                comp,
                                                                revision.annualGridComponents
                                                            )
                                                        }}
                                                    </div>
                                                }
                                                <div class="sum-label">{{
                                                    annualDetailsService.getTotalFMV(
                                                        revision.annualGridComponents,
                                                        viewTaxableValues
                                                    ) | number: '1.0-0'
                                                }}</div>
                                                <!-- data-sd-annual-year='{{year.annualYear1}}'>{{getTotalFMV(revision.annualGridComponents) | numeraljs:'0,0'}}</div>-->
                                                @for (
                                                    comp of annualDetailsService.capComponents(
                                                        components,
                                                        componentTypes,
                                                        viewTaxableValues
                                                    );
                                                    track comp;
                                                    let i = $index
                                                ) {
                                                    <div [ngClass]="{ 'cap-component': i === 0 }">{{
                                                        annualDetailsService.getDisplayAssessment(
                                                            comp,
                                                            revision.annualGridComponents
                                                        )
                                                    }}</div>
                                                }
                                                @if (viewTaxableValues) {
                                                    @for (
                                                        taxableValue of annualDetailsService.taxableValues(
                                                            revision,
                                                            annualDetailsService.getMaxNumberOfTaxableValues(years)
                                                        );
                                                        track i;
                                                        let i = $index
                                                    ) {
                                                        <div [ngClass]="{ 'cap-component': i === 0 }">{{
                                                            taxableValue
                                                        }}</div>
                                                    }
                                                }
                                            </div>
                                        </td>
                                    }
                                </tr>
                            </table>
                        </div>
                    </td>
                }
            </tr>
            <tr class="appeals-row"
                ><!-- data-sd-annual-year='{{year.annualYear1}}'>-->
                <td class="heading"> Appeals </td>
                <td class="heading">
                    <div>Resolution:</div>
                    <div>Savings:</div>
                </td>
                @for (year of years; track year) {
                    <td class="clickable" [class.expanded]="year.expanded" [style.cursor]="notAllowedIfConsolidated">
                        <!-- | orderBy: '-annualYear1'">-->
                        <div class="cell-item appeal-cell" [attr.data-sd-annual-year]="year.annualYear1">
                            <table style="width: 100%">
                                @if (year.expanded || year.annualGridDetails?.length < 2) {
                                    <tr>
                                        @for (revision of year.annualGridDetails; track revision) {
                                            <td
                                                class="revision"
                                                [class.collapsed-appeal-info]="!year.expanded"
                                                [class.under-appeal]="revision.isUnderAppeal"
                                                [style.cursor]="notAllowedIfConsolidated"
                                                (click)="appealClicked(year, revision)"
                                            >
                                                <div>
                                                    @if (revision.appealStatus !== 'Details') {
                                                        <span>{{ revision.appealStatus }}</span>
                                                    }
                                                    @if (revision.appealStatus === 'Details') {
                                                        <span class="anchor-style">{{ revision.appealStatus }}</span>
                                                    }
                                                </div>
                                                <div [class.invisible]="!revision.savings">{{
                                                    annualDetailsService.formatSavings(revision.savings) || '0'
                                                }}</div>
                                            </td>
                                        }
                                    </tr>
                                }
                                @if (!year.expanded && year.annualGridDetails?.length >= 2) {
                                    <tr>
                                        <td
                                            (click)="appealClicked(year)"
                                            class="revision"
                                            [class.under-appeal]="year.collapsedIsUnderAppeal"
                                            [style.cursor]="notAllowedIfConsolidated"
                                        >
                                            @if (year.collapsedAppealStatus !== 'Details') {
                                                <span>{{ year.collapsedAppealStatus }}</span>
                                            }
                                            @if (year.collapsedAppealStatus === 'Details') {
                                                <span class="anchor-style">{{ year.collapsedAppealStatus }}</span>
                                            }
                                            <div ng-class="{ invisible: !year.collapsedSavings }">{{
                                                annualDetailsService.formatSavings(year.collapsedSavings) || '0'
                                            }}</div>
                                        </td>
                                    </tr>
                                }
                            </table>
                        </div>
                    </td>
                }
            </tr>
            <tr>
                <td class="heading"> Taxes </td>
                <td class="heading">
                    <div>Total:</div>
                    <div>Eff. Rate:</div>
                    @if (isViewTrueRateBaseRateEnabled) {
                        <div>Base Rate:</div>
                    }
                </td>
                @for (year of years; track year) {
                    <td
                        class="clickable"
                        [class]="clickableTaxClass(year)"
                        style="padding: 0px"
                        [style.cursor]="notAllowedIfConsolidated"
                    >
                        <!-- | orderBy: '-annualYear1'">-->
                        <div class="cell-item taxes-cell"
                            ><!-- data-sd-annual-year='{{year.annualYear1}}'>-->
                            <table style="margin-left: initial">
                                <tr>
                                    <td
                                        class="revision"
                                        (click)="billClicked(year)"
                                        [attr.data-sd-annual-year]="year.annualYear1"
                                        [attr.data-sd-annual-year-tax-bill-cell]
                                        [style.cursor]="notAllowedIfConsolidated"
                                    >
                                        <!-- name="Parcel-{{parcel.parcelID}}-Year-{{year.annualYear1}}">-->
                                        <div>{{ year.totalTaxes | currency: 'USD' : 'symbol' }}</div>
                                        <!-- | numeraljs: '0,0.00'}}</div>-->
                                        <div>{{ year.effectiveRate | number: '1.6-6' }}%</div>
                                        <!--| numeraljs: '0.000000'}}%</div>-->
                                        @if (isViewTrueRateBaseRateEnabled) {
                                            <div>{{ year.trueRateBaseRate | number: '1.6-6' }}%</div>
                                        }
                                        <!--| numeraljs: '0.000000'}}%</div>-->
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </td>
                }
            </tr>
            @if (budgetsEnabled) {
                <tr>
                    <td class="heading">Budget</td>
                    <td class="heading"></td>
                    @for (year of years; track year) {
                        <td
                            class="clickable"
                            style="padding: 0px"
                            [style.pointer-events]="
                                year.latestBudgetId <= 0 && year.annualYear1 < 2019 ? 'none' : 'auto'
                            "
                            [style.cursor]="notAllowedIfConsolidated"
                        >
                            <!-- | orderBy: '-annualYear1'">-->
                            <div class="cell-item taxes-cell"
                                ><!-- data-sd-annual-year='{{year.annualYear1}}'>-->
                                <table style="margin-left: initial">
                                    <tr>
                                        <td
                                            class="revision"
                                            (click)="budgetClicked(year, year.latestBudgetId)"
                                            [attr.data-sd-annual-year]="year.annualYear1"
                                            [attr.data-sd-annual-year-budget-cell]
                                            [style.cursor]="notAllowedIfConsolidated"
                                        >
                                            <!-- name="Parcel-{{parcel.parcelID}}-Year-{{year.annualYear1}}">-->
                                            @if (year.latestBudgetId > 0) {
                                                <div>{{ year.latestBudgetAmount | currency: 'USD' : 'symbol' }}</div>
                                            }
                                            <!-- | numeraljs: '0,0.00'}}</div>-->
                                            @if (year.latestBudgetId <= 0) {
                                                <div>No Budget</div>
                                            }
                                            <!-- | numeraljs: '0,0.00'}}</div>-->
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    }
                </tr>
            }
        </tbody>
    </table>
    <!--<div class="button-container" style="margin-top: 30px;">
<button class="ace-btn btn-primary show-all-years" (click)="getAnnualGrid(true)" *ngIf="years?.length === 10">
  Show All Years
</button>
</div>-->
</div>
